import React from 'react';

const PageTitle = ({ left = false, center = false, children }) => {
    return (
        <div
            className={`font-favela-bold md:w-8/12 text-[20px] mx-auto bg-white w-full flex items-center ${
                left
                    ? 'justify-start'
                    : center
                      ? 'justify-center gap-8'
                      : 'justify-between'
            }`}
        >
            {children}
        </div>
    );
};

export default PageTitle;
